"use client";

import { useState } from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import { About } from "./components/About";
import { Badges } from "./components/Badges";
import { FloatingFish } from "./components/FloatingFish";
import { GhostBackground } from "./components/GhostBackground";
import { LoadingOverlay } from "./components/LoadingOverlay";
import { NoiseOverlay } from "./components/NoiseOverlay";
import { SpotifyCard } from "./components/SpotifyCard";
import { StatusGrid } from "./components/StatusGrid";
import { ThemeToggle } from "./components/ThemeToggle";
import { containerVariants, itemVariants } from "@/app/lib/animations";

export default function Home() {
  const [loading, setLoading] = useState(true);

  const handleLoadingComplete = () => {
    setLoading(false);
  };

  return (
    <>
      <LoadingOverlay visible={loading} onFinish={handleLoadingComplete} />
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: loading ? 0 : 1 }}
        transition={{ duration: 0.6 }}
        className={`${loading ? "pointer-events-none" : ""} relative min-h-screen overflow-hidden bg-background text-foreground`}
      > 
        <div className="absolute inset-0 bg-black/10 transition-colors duration-300" aria-hidden="true" />
        <NoiseOverlay />
        <FloatingFish />
        <div className="vignette pointer-events-none absolute inset-0" aria-hidden="true" />

        <div className="relative mx-auto flex min-h-screen w-full max-w-[420px] flex-col items-center justify-between px-6 py-12 sm:px-8 sm:py-16">
          <motion.div 
            className="absolute right-6 top-6 sm:right-8"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: loading ? 0 : 1, scale: loading ? 0.9 : 1 }}
            transition={{ duration: 0.4, delay: 0.6 }}
          >
            <ThemeToggle />
          </motion.div>

          <motion.main 
            className="flex w-full flex-col items-center text-center flex-1 justify-center"
            variants={containerVariants}
            initial="hidden"
            animate={loading ? "hidden" : "visible"}
          >
            <motion.div variants={itemVariants}>
              <About />
            </motion.div>

            <motion.div 
              className="mt-10 w-full"
              variants={itemVariants}
            >
              <StatusGrid />
            </motion.div>

            <motion.div 
              className="mt-10 w-full"
              variants={itemVariants}
            >
              <SpotifyCard />
            </motion.div>

            <motion.div 
              className="mt-10 w-full"
              variants={itemVariants}
            >
              <Badges />
            </motion.div>
          </motion.main>
        </div>
      </motion.div>
    </>
  );
}
